import { isUserSignedIn, getUserAuthValues } from "src/utils/generalUtils";
import RavenWebManager from "./ravenSDK";
import { isWindowPresent } from "src/utils/browserHelpers";
const { userId } = getUserAuthValues();
export const ravenCommonPayload = {
  userId: userId || "NA",
  platform: "Desktop",
  login_status: isUserSignedIn() ? "yes" : "no",
  vertical: "bus",
  domainName: isWindowPresent ? window.location.host : null,
  channel: "CT",
};

export const triggerRaven = (
  eventName: string,
  actionDetails: Record<string, unknown>,
  marTechUserAttributes?: Record<string, unknown> | null
) => {
  RavenWebManager.event(eventName, {
    ...actionDetails,
    ...ravenCommonPayload,
    ...marTechUserAttributes,
  });
};
